// app/javascript/controllers/confirm_delete_controller.js
import { Controller } from "@hotwired/stimulus"

// Sostituisce il data-confirm nativo del browser con un popup Bootstrap
// dove il focus di default e' sul bottone Annulla anziche' su OK.
export default class extends Controller {
  static targets = ["modal", "cancelButton"]

  connect() {
    this.modalInstance = new bootstrap.Modal(this.modalTarget)
    this.pendingLink = null

    this.modalTarget.addEventListener("shown.bs.modal", () => {
      this.cancelButtonTarget.focus()
    })
  }

  ask(event) {
    const link = event.currentTarget

    // Rilancio del click dopo la conferma: lascia proseguire Rails UJS
    // (che gestisce il data-method: delete) senza riaprire il popup.
    if (link.dataset.confirmed) {
      delete link.dataset.confirmed
      return
    }

    event.preventDefault()
    event.stopImmediatePropagation()

    this.pendingLink = link
    this.modalInstance.show()
  }

  confirm() {
    const link = this.pendingLink
    this.pendingLink = null

    this.modalInstance.hide()

    if (link) {
      link.dataset.confirmed = "true"
      link.click()
    }
  }

  cancel() {
    this.pendingLink = null
    this.modalInstance.hide()
  }
}
